
<div class="confirm__popup">
  <h3 mat-dialog-title>{{data.title}}</h3>
  <div mat-dialog-content>
    <p>{{data.message}}</p>
  </div>

  <div mat-dialog-actions>
    <div class="button__row">
      <button class="button--box red no" mat-button (click)="no()">No</button>
      <button class="button--box blue yes" mat-button (click)="yes()" cdkFocusInitial>Yes</button>
    </div>
  </div>
</div>
